<!-- Animated background elements -->
<div class="circuit-bg">
  <div class="circuit-line"></div>
  <div class="circuit-line"></div>
  <div class="circuit-line"></div>
  <div class="circuit-line"></div>
  <div class="circuit-line"></div>
  <div class="data-stream"></div>
  <div class="data-stream"></div>
  <div class="data-stream"></div>
</div>

<div class="floating-gear gear-1">⚙️</div>
<div class="floating-gear gear-2">⚙️</div>
<div class="floating-gear gear-3">⚙️</div>

<div class="error-container">
  <h1>Page Not Found!</h1>

  <p class="subtitle">
    Our robot searched everywhere, but this page seems to have been lost!
  </p>

  <div class="button-group">
    <button class="btn btn-primary" (click)="goHome()">
      <span class="icon">🏭</span>
      <span>Return to Home</span>
    </button>
  </div>


</div>
